import React from "react";
import filter from "../../assests/images/filter.svg";

export default function FilterMenuAgreement({ handleFilterChange, filters }) {
  return (
    <div className="dropdown">
      <button
        className="btn form-label filter-box"
        type="button"
        id="filter"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
      >
        <img src={filter} alt="" />
        <span style={{ paddingLeft: "8px" }}>Filter</span>
      </button>

      <ul
        className="dropdown-menu p-3"
        aria-labelledby="filter"
        id="AppDropDownId"
        style={{ minWidth: "18rem" }}
      >
        <li className="sub-step-link">Add Filters</li>
        <li>
          <div className="accordion" id="filterAgreementType">
            <div className="border-0" style={{ padding: "16px 0 0px 0" }}>
              <span>
                <button
                  className="accordion-button collapsed no-focus-outline"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFileType"
                  aria-expanded="false"
                  aria-controls="collapseFileType"
                  style={{ padding: "0 0 10px 0" }}
                >
                  <span
                    className="review-text menu-options"
                  >
                    Agreement Type
                  </span>
                </button>
              </span>
              <div
                id="collapseFileType"
                className="accordion-collapse collapse"
                data-bs-parent="#filterFileType"
              >
                <div className="pb-0 px-2">
                  <div className="form-check mb-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="agreement_type"
                      id="agreement_Fractions_FreeTrialAgreement"
                      value="Fractions_FreeTrialAgreement"
                      checked={filters.agreement_type === "Fractions_FreeTrialAgreement"}
                      onChange={() => { }}
                      onClick={(e) =>
                        handleFilterChange("agreement_type", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      Fraction - Free Trial
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="agreement_type"
                      id="agreement_Fractions_PerSampleToken_Agreement"
                      value="Fractions_PerSampleToken_Agreement"
                      checked={filters.agreement_type === "Fractions_PerSampleToken_Agreement"}
                      onChange={() => { }}
                      onClick={(e) =>
                        handleFilterChange("agreement_type", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      Fraction - Per Sample
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="agreement_type"
                      id="agreement_Fractions_SeatTokenAgreement"
                      value="Fractions_SeatTokenAgreement"
                      checked={filters.agreement_type === "Fractions_SeatTokenAgreement"}
                      onChange={() => { }}
                      onClick={(e) =>
                        handleFilterChange("agreement_type", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      Fraction - Seat Token
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="agreement_type"
                      id="agreement_HiRes_FreeTrialAgreement"
                      value="HiRes_FreeTrialAgreement"
                      checked={filters.agreement_type === "HiRes_FreeTrialAgreement"}
                      onChange={() => { }}
                      onClick={(e) =>
                        handleFilterChange("agreement_type", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      HiRes - Free Trial
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="agreement_type"
                      id="agreement_HiRes_PerSampleToken_Agreement"
                      value="HiRes_PerSampleToken_Agreement"
                      checked={filters.agreement_type === "HiRes_PerSampleToken_Agreement"}
                      onChange={() => { }}
                      onClick={(e) =>
                        handleFilterChange("agreement_type", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      HiRes - Per Sample
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="agreement_type"
                      id="agreement_HiRes_SeatTokenAgreement"
                      value="HiRes_SeatTokenAgreement"
                      checked={filters.agreement_type === "HiRes_SeatTokenAgreement"}
                      onChange={() => { }}
                      onClick={(e) =>
                        handleFilterChange("agreement_type", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      HiRes - Seat Token
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        {/* <li>
          <div className="accordion" id="filterType">
            <div className="border-0" style={{ padding: "16px 0 0px 0" }}>
              <button
                className="accordion-button collapsed no-focus-outline"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseType"
                aria-expanded="false"
                aria-controls="collapseType"
                style={{ padding: "0 0 10px 0" }}
              >
                <span className="review-text menu-options">Type</span>
              </button>

              <div
                id="collapseType"
                className="accordion-collapse collapse"
                data-bs-parent="#filterType"
              >
                <div className="pb-0 px-2">
                  <div className="form-check mb-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="type"
                      id="type_pdf"
                      value="pdf"
                      checked={filters.type === "pdf"}
                      onClick={(e) =>
                        handleFilterChange("type", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      PDF
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="type"
                      id="type_email"
                      value="email"
                      checked={filters.type === "email"}
                      onClick={(e) =>
                        handleFilterChange("type", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      Email
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="type"
                      id="type_focused"
                      value="focused"
                      checked={filters.type === "focused"}
                      onClick={(e) =>
                        handleFilterChange("type", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      Focused
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>


        <li>
          <div className="accordion" id="filterStatus">
            <div className="border-0" style={{ padding: "16px 0 0px 0" }}>
              <button
                className="accordion-button collapsed no-focus-outline"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseStatus"
                aria-expanded="false"
                aria-controls="collapseStatus"
                style={{ padding: "0 0 10px 0" }}
              >
                <span className="review-text menu-options">Status</span>
              </button>

              <div
                id="collapseStatus"
                className="accordion-collapse collapse"
                data-bs-parent="#filterStatus"
              >
                <div className="pb-0 px-2">
                  <div className="form-check mb-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id="yes"
                      value="1"
                      checked={filters.status === "1"}
                      onClick={(e) =>
                        handleFilterChange("status", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      Yes
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id="No"
                      value="0"
                      checked={filters.status === "0"}
                      onClick={(e) =>
                        handleFilterChange("status", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="accordion" id="filterSigned">
            <div className="border-0" style={{ padding: "16px 0 0px 0" }}>
              <button
                className="accordion-button collapsed no-focus-outline"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseSigned"
                aria-expanded="false"
                aria-controls="collapseSigned"
                style={{ padding: "0 0 10px 0" }}
              >
                <span className="review-text menu-options">Signed</span>
              </button>

              <div
                id="collapseSigned"
                className="accordion-collapse collapse"
                data-bs-parent="#filterSigned"
              >
                <div className="pb-0 px-2">
                  <div className="form-check mb-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="signed"
                      id="yes"
                      value="1"
                      checked={filters.signed === "1"}
                      onClick={(e) =>
                        handleFilterChange("signed", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      Yes
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="signed"
                      id="No"
                      value="0"
                      checked={filters.signed === "0"}
                      onClick={(e) =>
                        handleFilterChange("signed", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li> */}
      </ul>
    </div>
  );
}
